import React from 'react'
import { Box, Button, Flex, Heading, Message, Modal, Text } from '@workwhile/ui'
import { useDeleteBillRateFlowContextValue } from '../context/DeleteBillRateFlowProvider'
import { useBillRatesWorkflowsContextValue } from '../../../context/BillRatesWorkflowsProvider'
import { BillRate } from '../../../types'

export const DeleteBillRateFlowMain = ({
  billRate,
}: {
  billRate: BillRate
}) => {
  const {
    deleteBillRateFlow: { isOpen, close },
  } = useBillRatesWorkflowsContextValue()

  const {
    state: { isPending, errorMessage },
    actions: { confirm },
  } = useDeleteBillRateFlowContextValue()

  return (
    <Modal
      open={isOpen}
      onClose={close}
      position="top"
      loading={isPending}
      customCta={
        <Flex>
          <Button variant="text" onClick={close}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={confirm}>
            Deactivate
          </Button>
        </Flex>
      }
    >
      <Heading level={3} fontWeight="400" style={{ margin: 0 }}>
        Deactivate bill rate
      </Heading>
      <Box mt={4}>Company</Box>
      <Box color="lightText">
        {`${billRate.company.name} (${billRate.company.id})`}
      </Box>
      <Box mt={4}>Position</Box>
      <Box color="lightText">
        {`${billRate.position.name} (${billRate.position.id})`}
      </Box>
      <Text mt={3} style={{ paddingTop: 20 }}>
        <strong style={{ fontSize: '1.75rem' }}>
          Are you sure you want to deactivate this bill rate?
        </strong>
        <ul style={{ listStyleType: 'disc', paddingLeft: 20, paddingTop: 15 }}>
          <li>This action cannot be undone.</li>
          <li>New shifts won't be assigned to this bill rate.</li>
          <li>
            New shifts will use <strong>pay rate + fee</strong> unless you
            create a new bill rate for the position.
          </li>
          <li>
            Existing shifts already associated with this bill rate will continue
            to use this bill rate.
          </li>
        </ul>
      </Text>

      {errorMessage ? (
        <Message variant="error" mt={3} borderRadius="small">
          {errorMessage}
        </Message>
      ) : null}
    </Modal>
  )
}
